export const SUCCESS_STATUS = 'success';
export const CUSTOM_AUTH = 'CUSTOM_AUTH';
export const SOCIAL_AUTH_FACEBOOK = 'SOCIAL_AUTH_FACEBOOK';
export const SOCIAL_AUTH_GOOGLE = 'SOCIAL_AUTH_GOOGLE';
